import React from 'react';

function Advocacy() {
  return (
    <div className="advocacy">
      <h1>Advocacy & Policy</h1>
      {/* Add your advocacy content here */}
    </div>
  );
}

export default Advocacy;
